const SEGMENTER = typeof Intl.Segmenter === "function" ? new Intl.Segmenter() : undefined;

// What somebody reading the text calls a character: a flag, an emoji with a modifier and a letter with an accent
// after it are each one of these and several code points, and counting or reversing by code point takes all three
// apart. Read by /string, which reverses by them and counts them, and by /unicode, which says when the two differ.
export function graphemes(text: string): string[] {
  if (!SEGMENTER) return [...text];
  return Array.from(SEGMENTER.segment(text), (segment) => segment.segment);
}
